import { render } from "./swipeButton.vue?vue&type=template&id=507dcfc0"
import script from "./swipeButton.vue?vue&type=script&lang=js"
export * from "./swipeButton.vue?vue&type=script&lang=js"

import "./swipeButton.vue?vue&type=style&index=0&id=507dcfc0&lang=scss"
script.render = render

export default script